module.exports = __webpack_public_path__ + "media/assets/images/tenant_portal_showcase-2ce60d4149fe6391a0397a2df0e83178.png";